
import { ChangeDetectionStrategy, Component,  OnInit, input, output, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import type { PlanSummary } from '@fitness-force/models';
import { AuthSevices } from '@fitness-force/api';
import { Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { BillingSummaryComponent} from '../billing-summary/billing-summary.component';
import { PaymentStatusTimelineComponent} from '../payment-status-timeline/payment-status-timeline.component';
import { PosBillingSummaryComponent } from '../pos-billing-summary/pos-billing-summary.component';
import { LinkType } from '@fitness-force/enum';



@Component({
  selector: 'billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PaymentStatusTimelineComponent,
    BillingSummaryComponent,
    PosBillingSummaryComponent
]
})
export class BillingComponent implements OnInit {
  private readonly authService = inject(AuthSevices);


  readonly planSummary$ = input.required<Observable<PlanSummary>>({ alias: "planSummarydata" });
  readonly showbilling = input(false);
  readonly showPosBilling = input(false);
  readonly billedAtTenantId = input(0);
  readonly billedForTenantId = input(0);
  readonly isCartFlow = input<boolean>(false);  
  readonly linkType = input<LinkType>(LinkType.SignUp);

  readonly closeSidePopupMember = output<{
    hideSidebar: boolean;
    uuid: string | null;
    amendmentExecutedSuccessfully?: boolean;
}>();
  readonly GoToClientSubscription = output<boolean>();
  readonly GoToClientProfile = output<any>();
  readonly addToCart = output<{
    type: string;
    object: any;
}>();
  readonly clearCart = output<void>();


  showPaidFullSidebar$: Observable<boolean> | any = false;
  showPaymentStatusSidebar$: Observable<boolean> | any = false;
  skipPaymentPolling = false;
  uuid!: string;
  currentUserDetails: any;
  ispayment!: boolean;

  constructor() {
    this.currentUserDetails = this.authService.decodedToken;
  }

  ngOnInit(): void {
    this.showPaidFullSidebar$ = this.showbilling();
  }

  HidePaymentSummary(evt: any) {
    this.showPaymentStatusSidebar$ = false;
    this.skipPaymentPolling = false;
    this.closeSidePopupMember.emit({ hideSidebar: false, uuid: this.uuid });
  }

  CloseBillingSummary(evt: any) {
    if (evt.amendmentExecutedSuccessfully) {
      this.clearCart.emit();
      this.showPaidFullSidebar$ = false;
      this.showPaymentStatusSidebar$ = false;
      this.skipPaymentPolling = false;
      this.closeSidePopupMember.emit({
        hideSidebar: false,
        uuid: null,
        amendmentExecutedSuccessfully: true,
      });
      return;
    }

    if (evt.clientSignupUUID && !evt.suppressPaymentTimeline) {
      this.clearCart.emit();
      this.showPaidFullSidebar$ = false;
      this.uuid = evt.clientSignupUUID;
      this.skipPaymentPolling = !!evt.skipPaymentPolling;
      this.showPaymentStatusSidebar$ = true;
      if (evt.ispayment) {
        this.ispayment = evt.ispayment;
      }
    }
    else {
      this.showPaymentStatusSidebar$ = false;
      this.skipPaymentPolling = false;
      this.closeSidePopupMember.emit({ hideSidebar: false, uuid: this.uuid });
    }
  }

  GoToClientDetails(event: any) {
    this.GoToClientSubscription.emit(event);
  }

  AddToCart(event: any) {
    this.showPaidFullSidebar$ = false;
    this.showPaymentStatusSidebar$ = false;
    this.addToCart.emit(event);
  }
}